import { CourierScheduleResponse, CourierWorkSchedulesFilter } from '@core/interfaces/courier-shedule.interface';
import { NgbDateRange } from '@core/interfaces/date-filter.interface';

export class GetCourierSchedules {
  static readonly type = '[GetCourierSchedules] Get Courier Schedules';

  constructor(public courierWorkSchedulesFilter: CourierWorkSchedulesFilter) {}
}

export class UpdateCourierSchedule {
  static readonly type = '[UpdateCourierSchedule] Update Courier Schedule';

  constructor(public courierScheduleData: CourierScheduleResponse) {}
}

export class ArchiveCourierSchedules {
  static readonly type = '[ArchiveCourierSchedules] Archive Courier Schedules';

  constructor(
    public id: number,
    public archivedAt: string,
  ) {}
}

export class ResetCourierSchedules {
  static readonly type = '[CourierSchedules] Reset';
}

export class SetSchedulesFilter {
  static readonly type = '[SetSchedulesFilter] Set Schedules Filter';

  constructor(public filter: CourierWorkSchedulesFilter) {}
}

export class SetSchedulesDateFilter {
  static readonly type = '[SetSchedulesDateFilter] Set Schedules Date Filter';

  constructor(public dateFilter: NgbDateRange) {}
}
